import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguagesService } from "@easyfo/common-lib";
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { UsersService } from '../../services/user';

@Component({
  selector: 'app-register-form',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  showAlertBox: boolean = false;
  alertMessage: string = '';
  submiting: boolean = false;
  matchPassword: boolean = false;
  filteringCtrl: FormControl = new FormControl();
  searchingText: string = ''

  username: string | undefined;
  password: string | undefined;
  confirmPassword: string | undefined;
  firstname: string | undefined;
  middlename: string | undefined;
  lastname: string | undefined;
  language: string | undefined;

  // select language option
  languageFromControl = new FormControl();
  languages = new Array();

  isShowPassword: boolean = false;
  isConfirmShowPassword: boolean = false;
  constructor(private titleService: Title,
    private _userService: UsersService,
    private translate: TranslateService,
    private _languagesService: LanguagesService,
    private router: Router) {
    this.titleService.setTitle("User Registration");

    this._languagesService.setDefault();
    this.addLanguages('en', 'language.en');
    this.addLanguages('th', 'language.th');
    this.addLanguages('my', 'language.my');
    this.addLanguages('km', 'language.km');
    this.addLanguages('vi', 'language.vi');
    this.addLanguages('lo', 'language.lo');
  }

  ngOnInit(): void {
    this.filteringCtrl.valueChanges.subscribe((value: any) => {
      this.searchingText = value
    });
  }

  onRegister() {
    this.submiting = true;
    this.showAlertBox = false;

    // Check empty value
    if (!this._userService.checkEmptyValue(this.username, this.password, this.confirmPassword, this.firstname,
      this.lastname, this.language)) return;

    // Check password matching
    if (this.password != this.confirmPassword) {
      this.alertMessage = 'The password confirmation does not match';
      this.submiting = false;
      this.matchPassword = false;
      return;
    } else {
      this.matchPassword = true;
    }

    // Call register service
    this._userService.requestRegister(this.username!, this.password!, this.firstname!, this.middlename!, this.lastname!, this.language!, (res) => {
      // Success
      if (res.success) {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: this._userService.alertMsg,
          showConfirmButton: true,
          customClass: environment.alert_sweet,
          buttonsStyling: false,
        }).then(() => {
          this.router.navigate(['/login']);
        });
        return;
      }

      // Failed
      this.submiting = false;
      this.showAlertBox = true;
      this.alertMessage = this._userService.alertMsg;
    }
    );
  }

  private addLanguages(code: string, key: string) {
    this.translate.get(key).subscribe((value: string) => {
      this.languages.push({
        id: code,
        name: value
      });
    });
  }
}
